<button mat-icon-button [matMenuTriggerFor]="notificationCenter" class="notifications-menu d-flex align-items-center justify-content-center position-relative">
    <svg-icon src="assets/icons/bell.svg" class="bell-icon d-flex align-items-center justify-content-center"/>
    @if (total() > 0)
    {
        <div class="notification-counter position-absolute">
            <p class="nunito-regular">{{total()}}</p>
        </div>
    }
</button>
<mat-menu #notificationCenter="matMenu">
    <div class="d-flex flex-column gap-3 w-100 h-100 notification-center">
        @for (notification of notifications(); track $index)
        {
            <app-notification-item [notification]="notification" (pressed)="markAsRead(notification.id)"/>
        }
        @empty 
        {
            <div class="no-notifications d-flex align-items-center justify-content-center">
                <p class="nunito-regular">{{'NOTIFICATIONS.NO_NOTIFICATIONS' | translate}}</p>
            </div>
        }
    </div>
</mat-menu>
